// @author Jayden Scahill - Old Mate Developments

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

export function AuthLayout() {
  const { user } = useAuthStore();

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-dark-900 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md space-y-8">
        <div className="flex flex-col items-center">
          <img 
            src="https://images.squarespace-cdn.com/content/v1/647c3d112b1bdd6e67652190/e464721a-ccc9-4af0-86fb-8fba7f032118/omvs-logo-003-dark.png?t=1739510093111"
            alt="Old Mate Ticket Management"
            className="h-12 w-auto"
          />
          <h2 className="mt-6 text-3xl text-center font-bold text-white">
            Old Mate Ticket Management
          </h2>
        </div>
        <div className="bg-dark-800 py-8 px-4 shadow rounded-lg sm:px-10">
          <Outlet />
        </div>
      </div>
    </div>
  );
}